import { DefaultDetailContext } from 'src/app/controls/forms/default-detail-context';
import { IFolderState } from 'src/app/models/interfaces/folder-state.interface';

export class FolderStateDetailContext extends DefaultDetailContext<IFolderState, number> {}
